<template>
  <div class="container">
    <van-cell
      class="header"
      :title="`总金额：${receivableAmount}元 `"
      title-class="total"
      :value="`剩余待抵扣：${overdue}元`"
      value-class="left"
    />
    <van-list>
      <van-cell>
        <div
          v-if="list && list.length > 0"
          class="row title"
        >
          <span class="item">时间</span>
          <span class="item">抵扣金额（元）</span>
        </div>
      </van-cell>
      <van-cell
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="row">
          <span class="item">{{ item.billMonth }}</span>
          <span class="item">{{ item.receivedAmount | formatAmount }}</span>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import BillApi from '@/api/bill';
import STATUS from '@/constants/status';
import { formatAmount } from '@/util/filter';

export default {
  name: 'ReceivableHistory',
  data() {
    return {
      list: [],
      receivableAmount: '0',
      overdue: '0',
    };
  },
  async mounted() {
    const {
      billNo: settlementId,
    } = this.$route.query;
    const res = await BillApi.getReceivable({ settlementId });
    if (res.code === STATUS.SUCCESS) {
      const data = res.data || {};
      this.list = data.offsetDetail || [];
      this.receivableAmount = formatAmount(data.receivableAmount || 0);
      this.overdue = formatAmount(data.overdue || 0);
    }
  },
};
</script>

<style lang="scss" scoped>
  .header {
    border-bottom: 0.02rem solid #969799;
    .total{
      font-weight: bold;
      font-size: 0.3rem;
      color: black;
      text-align: left;
    }
    .left {
      @extend .total;
      text-align: right;
    }
  }
  .row {
    display: flex;
    background-color: white;
    .item {
      text-align: center;
      flex: 1;
    }

    &.title {
      font-weight: bold;
    }
  }
</style>
